export const exportToCSV = (data, filename) => {
    const raw = typeof data === 'function' ? data() : data;
    if (!raw || !raw.length) {
        console.warn("No data to export");
        return;
    }

    // Get headers from the first object
    const headers = Object.keys(raw[0]);

    // Create CSV content
    const csvContent = [
        headers.join(','), // Header row
        ...raw.map(row => headers.map(header => {
            const cell = row[header] === null || row[header] === undefined ? '' : row[header];
            let stringCell = typeof cell === 'object' ? JSON.stringify(cell) : String(cell);
            if (stringCell.includes(',') || stringCell.includes('"') || stringCell.includes('\n')) {
                return `"${stringCell.replace(/"/g, '""')}"`;
            }
            return stringCell;
        }).join(','))
    ].join('\n');

    // Create blob and download link
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `${filename}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }
};

export const exportToJSON = (data, filename) => {
    const raw = typeof data === 'function' ? data() : data;
    if (!raw || !raw.length) {
        console.warn("No data to export");
        return;
    }

    const jsonContent = JSON.stringify(raw, null, 2);
    const blob = new Blob([jsonContent], { type: 'application/json;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `${filename}.json`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }
};
